import netteForms from 'nette-forms';
netteForms.initOnLoad();
import 'plugins/cookie-bar/cookie-bar-naja.js';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
// import simpleLightbox from "simplelightbox/dist/simple-lightbox.jquery";

// <script src="{$basePath}/public/js/jquery.js"></script>
//     <!--[if lt IE 10]> <script type="text/javascript" src="{$basePath}/public/js/ie8.js"></script> <![endif]-->
// <script src="{$basePath}/public/js/plugins.js"></script>
// <script src="{$basePath}/public/js/contact.form.js"></script>
// <script src="{$basePath}/public/js/init.js"></script>

// import './contact.form.js';
//import './init.js';

$(document).ready(function () {
    window.app = new App();
    window.app.init();
});

function LoaderExtension(naja) {
    naja.addEventListener('init', function () {
        window.app = new App();
        window.app.init();
    }.bind(this));

    naja.addEventListener('complete', hideLoader.bind(this));
    naja.addEventListener('complete', hideLoader.bind(this));

    function hideLoader() {
        window.app.reload();
    }

    return this;
}

var App = function () {
};

App.prototype.init = function () {
    var self = this;


    naja.initialize();
    naja.addEventListener('complete', hideLoader.bind(this));

    function hideLoader() {
        window.app.reload();
    }

    naja.addEventListener('start', start.bind(this));
    naja.addEventListener('complete', complete.bind(this));
    naja.addEventListener('interaction', test.bind(this));

    // naja.addEventListener('complete', test2.bind(this));

    function start(e) {
        $('.animateAjax').prepend('<span class="loader-circle-wrapper"><span class="loader-circle"></span></span>');
        $('.animateAjax').prop("disabled", true);
    }

    function complete(e) {
        window.app.reload();

        $('.animateAjax').find('.loader-circle-wrapper').remove();
        $('.animateAjax').prop("disabled", false);

    }

    function test(event) {
        (event.element.hasAttribute("data-confirm")
            && !confirm(event.element.getAttribute("data-confirm")))
        && event.preventDefault();
    }

    $(window).on('popstate', function (e) {
        self.paginatorFakeLink();
    });

    self.reload();
    this.initWebStaff();
};

App.prototype.initWebStaff = function () {
    $('.menu_toggler').click(function () {
        $(this).toggleClass("active");
        $(".menu_toggler .menu_icon").toggleClass("open");
        $(".header_menu_wrapper").slideToggle();
    });

    let lastScrollTop = 0;
    const header = $('.main_header');
    const headerHeight = header.outerHeight();
    let isAnimating = false;

    $(window).scroll(function () {
        const scrollTop = $(this).scrollTop();

        if (scrollTop > 200) {
            if (!isAnimating) {
                if (scrollTop > lastScrollTop) {
                    // Scrolling down
                    isAnimating = true;
                    header.stop().animate({
                        top: -headerHeight
                    }, 400, function () {
                        isAnimating = false;
                    });
                } else {
                    // Scrolling up
                    isAnimating = true;
                    header.stop().animate({
                        top: 0
                    }, 400, function () {
                        isAnimating = false;
                    });
                }
            }
        } else {
            // Reset header position if less than 400px from top
            if (!isAnimating) {
                isAnimating = true;
                header.stop().animate({
                    top: 0
                }, 400, function () {
                    isAnimating = false;
                });
            }
        }

        lastScrollTop = scrollTop;
    });

    const video = $('#videoPlayer');
    if (video.length) {
        const playPauseButton = $('#playPauseButton');
        playPauseButton.find('.play_icon').hide();
        playPauseButton.on('click', () => {
            if (video[0].paused) {
                video[0].play();
                playPauseButton.find('.play_icon').hide();
                playPauseButton.find('.pause_icon').show();
            } else {
                video[0].pause();
                playPauseButton.find('.pause_icon').hide();
                playPauseButton.find('.play_icon').show();
            }
        });
    }

    Swiper.use([Navigation]);

    if ($('.swiper-articles').length) {
        var swiper_articles = new Swiper('.swiper-articles', {
            slidesPerView: 'auto',
            spaceBetween: 22,
            centeredSlides: false,
            centerMode: false,
            loop: true,
            navigation: {
                nextEl: '#article_next',
                prevEl: '#article_prev',
            },
            breakpoints: {
                576: {
                    centeredSlides: true,
                    centerMode: true,
                }
            }
        });
    }

    if ($('.swiper-ilustrations').length) {
        var swiper_ilustrations = new Swiper('.swiper-ilustrations', {
            slidesPerView: 'auto',
            spaceBetween: 22,
            loop: true,
            navigation: {
                nextEl: '#ilustrations_next',
                prevEl: '#ilustrations_prev',
            }
        });
    }

    if ($('.swiper-gallery').length) {
        var swiper_gallery = new Swiper('.swiper-gallery', {
            slidesPerView: 'auto',
            spaceBetween: 22,
            loop: true,
            navigation: {
                nextEl: '#gallery_next',
                prevEl: '#gallery_prev',
            }
        });
    }

    if ($('.swiper-merch').length) {
        var swiper_merch = new Swiper('.swiper-merch', {
            slidesPerView: 'auto',
            spaceBetween: 22,
            loop: true,
            navigation: {
                nextEl: '#merch_next',
                prevEl: '#merch_prev',
            }
        });
    }

    if ($('.swiper-team_nembers').length) {
        var swiper_members = new Swiper('.swiper-team_nembers', {
            slidesPerView: 'auto',
            spaceBetween: 22,
            loop: true,
            navigation: {
                nextEl: '#team_next',
                prevEl: '#team_prev',
            }
        });
    }

    if ($('.fixed_el__visit_us__title').length) {
        $('.fixed_el__visit_us__title').on('click', function () {
            $('.fixed_el').toggleClass('active');
            $('html, body').animate({
                scrollTop: $(document).height()
            }, 'fast');
        });
    }

    if ($('.faq').length) {
        $('.faq_item__title').on('click', function () {
            var $faqItem = $(this).closest('.faq_item');
            $faqItem.toggleClass('active');
            $faqItem.find('.faq_item__content').slideToggle();
        });
    }
};

App.prototype.reload = function () {
    // this.initPagination();
    this.paginatorFakeLink();

    $('.more_button_photos').off('click').on('click', function (e) {
        e.preventDefault();
        $(".gallery_detail__item.d-none").removeClass("d-none");
        $(this).remove();
    })
};

App.prototype.paginatorFakeLink = function () {
    var self = this;

    $('.productDetailShow').off('click').on('click', function (e) {
        $("html, body").animate({scrollTop: $('#snippet--pageContent').offset().top}, 0);
    });

    $('.paginatorFakeLink').off('click').on('click', function (e) {
        e.preventDefault();

        naja.makeRequest('POST', $(this).data('link'))
            .then(function (payload) {
                if (self.firstClick) {
                    // self.autoPaginator();
                    self.firstClick = false;
                }
                self.enabledAuto = true;

                console.log('okkk');
                $(document).off('click').on('click', '.productDetailShow', function (e) {
                    console.log('scroool');

                    $("html, body").animate({scrollTop: $('#snippet--pageContent').offset().top}, 0);
                });
            })
            .catch(function (error) {
                console.log(error);
            });
    });
}
